(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    const setupLastImageHover = (root = document) => {
      root
        .querySelectorAll('results-list[data-hover-last-image="true"] template[data-product-hover-last-image]')
        .forEach((template) => {
          const card = template.closest('.product-grid__item');
          const primaryImage = card?.querySelector('.product-media__image');
          const imageContainer = primaryImage?.closest('.product-media') || primaryImage?.parentElement;
          const hoverImage = template.content.firstElementChild?.cloneNode(true);

          if (!card || !primaryImage || !imageContainer || !hoverImage) return;

          hoverImage.classList.add('product-card__hover-last-image');
          hoverImage.setAttribute('aria-hidden', 'true');
          imageContainer.classList.add('product-card__hover-image-container');
          imageContainer.appendChild(hoverImage);
          card.classList.add('product-grid__item--hover-last-image');
          template.remove();
        });
    };

    const initializeLastImageHover = (root = document) => {
      setupLastImageHover(root);

      root.querySelectorAll('results-list[data-hover-last-image="true"]').forEach((resultsList) => {
        if (resultsList.dataset.lastImageHoverInitialized === 'true') return;

        resultsList.dataset.lastImageHoverInitialized = 'true';
        new MutationObserver(() => setupLastImageHover(resultsList)).observe(resultsList, {
          childList: true,
          subtree: true,
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeLastImageHover(), { once: true });
    } else {
      initializeLastImageHover();
    }

    document.addEventListener('shopify:section:load', (event) => initializeLastImageHover(event.target));
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-showcase]').forEach((section) => {
    const track = section.querySelector('[data-psc-track]');
    const previous = section.querySelector('[data-psc-previous]');
    const next = section.querySelector('[data-psc-next]');

    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maximum = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    };

    const scroll = (direction) => {
      const card = track.querySelector('.psc-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const setupSearchLastImageHover = (root = document) => {
    root
      .querySelectorAll('results-list[data-hover-last-image="true"] template[data-product-hover-last-image]')
      .forEach((template) => {
        const card = template.closest('.product-grid__item');
        const primaryImage = card?.querySelector('.product-media__image');
        const imageContainer = primaryImage?.closest('.product-media') || primaryImage?.parentElement;
        const hoverImage = template.content.firstElementChild?.cloneNode(true);

        if (!card || !primaryImage || !imageContainer || !hoverImage) return;

        hoverImage.classList.add('product-card__hover-last-image');
        hoverImage.setAttribute('aria-hidden', 'true');
        imageContainer.classList.add('product-card__hover-image-container');
        imageContainer.appendChild(hoverImage);
        card.classList.add('product-grid__item--hover-last-image');
        template.remove();
      });
  };

  const initializeSearchLastImageHover = (root = document) => {
    setupSearchLastImageHover(root);

    root.querySelectorAll('results-list[data-hover-last-image="true"]').forEach((resultsList) => {
      if (resultsList.dataset.lastImageHoverInitialized === 'true') return;

      resultsList.dataset.lastImageHoverInitialized = 'true';
      new MutationObserver(() => setupSearchLastImageHover(resultsList)).observe(resultsList, {
        childList: true,
        subtree: true,
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSearchLastImageHover(), { once: true });
  } else {
    initializeSearchLastImageHover();
  }

  document.addEventListener('shopify:section:load', (event) => initializeSearchLastImageHover(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('dragstart', (event) => {
    if (event.target instanceof HTMLImageElement && event.target.closest('.slideshow-2610126-optimized')) {
      event.preventDefault();
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-email-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPopup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('dialog');
      const closeButton = root.querySelector('[data-welcome-close]');
      const success = Boolean(root.querySelector('[data-welcome-success="true"]'));
      const sectionId = root.dataset.sectionId;
      const frequency = root.dataset.frequency;
      const delay = Number(root.dataset.delay || 0) * 1000;
      const speed = Number(root.dataset.speed || 300);
      const localKey = `welcome-popup-${sectionId}`;
      const sessionKey = `${localKey}-session`;

      if (!dialog || root.dataset.enabled !== 'true') return;

      const readStorage = (storage, key) => {
        try {
          return storage.getItem(key);
        } catch {
          return null;
        }
      };

      const writeStorage = (storage, key, value) => {
        try {
          storage.setItem(key, value);
        } catch {
          return;
        }
      };

      const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);

      const shouldShow = () => {
        if (isThemeEditor || success || frequency === 'always') return true;
        if (frequency === 'session') return !readStorage(sessionStorage, sessionKey);

        const storedValue = readStorage(localStorage, localKey);
        if (frequency === 'once') return !storedValue;

        const days = Number(frequency);
        const lastSeen = Number(storedValue || 0);
        return !lastSeen || Date.now() - lastSeen >= days * 86400000;
      };

      const rememberDismissal = () => {
        if (isThemeEditor || frequency === 'always') return;
        if (frequency === 'session') {
          writeStorage(sessionStorage, sessionKey, '1');
          return;
        }
        writeStorage(localStorage, localKey, String(Date.now()));
      };

      const openPopup = () => {
        if (!dialog.open) dialog.showModal();
        requestAnimationFrame(() => dialog.classList.add('is-visible'));
        const successMessage = dialog.querySelector('[data-welcome-success="true"]');
        if (successMessage) successMessage.focus();
      };

      const closePopup = () => {
        if (!dialog.open) return;
        dialog.classList.remove('is-visible');
        rememberDismissal();
        window.setTimeout(() => {
          if (dialog.open) dialog.close();
        }, speed);
      };

      closeButton?.addEventListener('click', closePopup);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closePopup();
      });
      root.addEventListener('welcome-popup:open', openPopup);

      if (success) rememberDismissal();
      if (shouldShow()) window.setTimeout(openPopup, success ? 0 : delay);
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-welcome-popup]').forEach(initPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const root = event.target.querySelector('[data-welcome-popup]');
      if (!root) return;
      initPopup(root);
      root.dispatchEvent(new CustomEvent('welcome-popup:open'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuemail1014"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('exit-email-popup')) {
    customElements.define('exit-email-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.editor = Boolean(window.Shopify?.designMode);
        this.key = 'exit-email-popup:v1:';
        this.timers = new Set();
        this.busy = false;
        const on = (target, type, handler, extra = {}) => target.addEventListener(type, handler, { ...extra, signal: this.controller.signal });
        this.launcher = this.querySelector('.ep-launcher');
        if (this.launcher) {
          this.launcher.hidden = false;
          on(this.launcher, 'click', () => this.open(true));
          on(this.dialog, 'close', () => this.launcher.setAttribute('aria-expanded', 'false'));
        }
        on(this.querySelector('.ep-close'), 'click', () => this.close());
        on(this.dialog, 'cancel', e => { e.preventDefault(); this.close(); });
        on(this.dialog, 'click', e => {
          const r = this.dialog.getBoundingClientRect();
          if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) this.close();
        });
        this.setupSubmission(on);
        if (this.editor) {
          if (this.dataset.preview === 'true') this.later(() => this.open(true), 200);
          on(document, 'shopify:section:select', e => { if (e.target.contains(this)) this.open(true); });
          on(document, 'shopify:section:deselect', e => { if (e.target.contains(this)) this.close(); });
          return;
        }
        if (this.dataset.enabled !== 'true') return;
        if (this.querySelector('[data-ep-success], [data-ep-errors]')) this.later(() => this.open(true), 200);
        on(document, 'click', e => {
          if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
          const link = e.target.closest('a[href]');
          if (link && !link.download && (!link.target || link.target === '_self') && this.isCheckout(link.href)) this.checkoutIntent = Date.now();
        }, { capture: true });
        on(document, 'submit', e => {
          if (this.contains(e.target)) return;
          const button = e.submitter;
          if (button?.name === 'checkout' || this.isCheckout(button?.formAction || e.target.action || '')) this.checkoutIntent = Date.now();
        }, { capture: true });
        on(window, 'pagehide', () => {
          if (this.checkoutIntent && Date.now() - this.checkoutIntent < 15000) {
            this.write('checkout', { time: Date.now() });
            this.remove('cart');
          } else if (this.dataset.page === 'cart') this.write('cart', { time: Date.now() });
          this.checkoutIntent = 0;
          this.close(true);
        });
        on(window, 'pageshow', () => {
          this.nativeRetry = false;
          if (!this.busy) this.clearPending();
          this.checkReturn();
        });
        on(document, 'mouseout', e => {
          if (this.dataset.page === 'cart' && this.dataset.intent === 'true' && !e.relatedTarget && e.clientY <= 0 && matchMedia('(hover:hover) and (pointer:fine)').matches) this.open();
        });
        this.checkReturn();
        if (this.dataset.delayEnabled === 'true') this.later(() => this.open(), Number(this.dataset.delay) * 1000);
      }
      setupSubmission(on) {
        if (this.dataset.submissionMode !== 'ajax') {
          on(window, 'submit', e => {
            if (e.target !== this.form) return;
            if (this.editor) {
              e.preventDefault();
              this.querySelector('[data-ep-status]').textContent = '请在店铺预览页面测试实际订阅。';
              return;
            }
            this.showPending();
          }, { capture: true });
          on(this.querySelector('[data-ep-retry]'), 'click', () => {
            if (!this.form.reportValidity()) return;
            this.clearPending();
            this.form.requestSubmit();
          });
          return;
        }
        this.originalSubmit = Object.getOwnPropertyDescriptor(this.form, 'submit');
        this.submitBridge = () => {
          if (this.nativeRetry) HTMLFormElement.prototype.submit.call(this.form);
          else this.submit();
        };
        this.form.submit = this.submitBridge;
        on(window, 'submit', e => {
          if (e.target !== this.form || this.editor || this.nativeRetry || this.completed) return;
          this.showPending();
        }, { capture: true });
        on(window, 'submit', e => {
          if (e.target !== this.form || this.nativeRetry || e.defaultPrevented) return;
          this.submit(e);
        });
        on(this.querySelector('[data-ep-retry]'), 'click', () => {
          if (this.busy || !this.form.reportValidity()) return;
          this.nativeRetry = true;
          this.form.requestSubmit();
        });
      }
      disconnectedCallback() {
        this.close(true);
        if (this.form?.submit === this.submitBridge) {
          if (this.originalSubmit) Object.defineProperty(this.form, 'submit', this.originalSubmit);
          else delete this.form.submit;
        }
        this.controller?.abort();
        this.controller = null;
        this.timers?.forEach(clearTimeout);
      }
      later(fn, ms) { const id = setTimeout(() => { this.timers.delete(id); if (this.isConnected) fn(); }, ms); this.timers.add(id); }
      read(name) { try { return JSON.parse(sessionStorage.getItem(this.key + name)); } catch { return null; } }
      write(name, value) { try { sessionStorage.setItem(this.key + name, JSON.stringify(value)); } catch { this.storageUnavailable = true; } }
      remove(name) { try { sessionStorage.removeItem(this.key + name); } catch {} }
      isCheckout(href) { try { const u = new URL(href, location.href); return u.origin === location.origin && /\/(checkout|checkouts)(\/|$)/.test(u.pathname); } catch { return false; } }
      async checkReturn() {
        if (this.checking || this.editor) return;
        this.checking = true;
        const checkout = this.read('checkout');
        const cart = this.read('cart');
        this.remove('checkout');
        this.remove('cart');
        const fresh = item => item && Date.now() - item.time >= 0 && Date.now() - item.time < Number(this.dataset.window) * 60000;
        try {
          if (fresh(checkout) && this.dataset.checkout === 'true') {
            const response = await fetch(this.dataset.root + 'cart.js', { credentials: 'same-origin', signal: AbortSignal.timeout(8000), cache: 'no-store' });
            if (response.ok && (await response.json()).item_count > 0) this.later(() => this.open(), 350);
          } else if (fresh(cart) && this.dataset.cart === 'true' && this.dataset.page !== 'cart') this.later(() => this.open(), 350);
        } catch {} finally { this.checking = false; }
      }
      open(force = false) {
        if (!this.isConnected || this.dialog.open || (!force && (this.shown || this.read('shown')))) return;
        if (!force && document.querySelector('dialog[open]')) return;
        this.dialog.showModal();
        this.launcher?.setAttribute('aria-expanded', 'true');
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.shown = true;
        if (!this.editor) this.write('shown', true);
        requestAnimationFrame(() => requestAnimationFrame(() => { if (this.dialog.open) this.dialog.classList.add('ep-visible'); }));
      }
      close(immediate = false) {
        if (!this.dialog?.open) return;
        this.dialog.classList.remove('ep-visible');
        const finish = () => { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow ?? ''; };
        if (immediate) finish(); else this.later(finish, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : Number(this.dataset.duration));
      }
      showPending() {
        const button = this.form.querySelector('[type="submit"]');
        if (!button || this.pending) return;
        this.pending = true;
        this.idleButtonText = button.textContent;
        button.textContent = this.querySelector('[data-ep-message="loading"]').textContent;
        this.form.setAttribute('aria-busy', 'true');
        this.querySelector('[data-ep-status]').textContent = '';
        this.querySelector('[data-ep-retry]').hidden = true;
        const attempt = this.pendingAttempt = (this.pendingAttempt || 0) + 1;
        this.later(() => {
          if (this.pending && !this.busy && this.pendingAttempt === attempt) {
            this.clearPending();
            this.querySelector('[data-ep-status]').textContent = this.querySelector('[data-ep-message="challenge"]').textContent;
            this.querySelector('[data-ep-retry]').hidden = false;
          }
        }, 25000);
      }
      clearPending() {
        const button = this.form.querySelector('[type="submit"]');
        if (button) {
          if (this.pending) button.textContent = this.idleButtonText;
          button.disabled = false;
        }
        this.pending = false;
        this.form.removeAttribute('aria-busy');
      }
      async readSubmissionResponse(response) {
        const parser = new DOMParser();
        if (!response.body?.getReader || typeof TextDecoder === 'undefined') {
          return parser.parseFromString(await response.text(), 'text/html');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let text = '';
        let lastEnd = -1;
        try {
          while (true) {
            const { done, value } = await reader.read();
            text += done ? decoder.decode() : decoder.decode(value, { stream: true });
            const end = text.lastIndexOf('</form>');
            if (end > lastEnd) {
              lastEnd = end;
              if (text.includes(this.form.id)) {
                const html = parser.parseFromString(text.slice(0, end + 7), 'text/html');
                const returned = html.getElementById(this.form.id);
                if (returned?.querySelector('[data-ep-success], [data-ep-errors]')) {
                  reader.cancel().catch(() => {});
                  return html;
                }
              }
            }
            if (done) return parser.parseFromString(text, 'text/html');
          }
        } finally { reader.releaseLock(); }
      }
      async submit(event) {
        if (event?.defaultPrevented) return;
        event?.preventDefault();
        if (this.busy || this.completed || !this.form.reportValidity()) return;
        const status = this.querySelector('[data-ep-status]');
        const retry = this.querySelector('[data-ep-retry]');
        const message = key => this.querySelector('[data-ep-message="' + key + '"]').textContent;
        if (this.editor) { status.textContent = '请在店铺预览页面测试实际订阅。'; return; }
        this.showPending();
        this.busy = true;
        const button = this.form.querySelector('[type="submit"]');
        button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        status.textContent = '';
        retry.hidden = true;
        try {
          const body = new FormData(this.form);
          body.delete('return_to');
          const action = new URL(this.form.action, location.href);
          action.hash = '';
          ['customer_posted', 'contact_posted', 'return_to'].forEach(key => action.searchParams.delete(key));
          const response = await fetch(action.href, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(20000) });
          const resultURL = new URL(response.url, location.href);
          if (/\/challenge(?:\/|$)/.test(resultURL.pathname)) {
            status.textContent = message('challenge'); retry.hidden = false; return;
          }
          const html = await this.readSubmissionResponse(response);
          const returned = html.getElementById(this.form.id);
          const errors = returned?.querySelector('[data-ep-errors]');
          const challenge = html.querySelector('form[action*="/challenge"], #shopify-challenge__container, .shopify-challenge__container');
          if (challenge) {
            status.textContent = message('challenge'); retry.hidden = false; return;
          }
          if (response.ok && !errors && returned?.querySelector('[data-ep-success]')) {
            this.completed = true;
            this.form.querySelector('.ep-fields').hidden = true;
            this.form.querySelector('.ep-fields').style.display = 'none';
            status.textContent = message('success');
          } else {
            status.textContent = errors?.textContent.trim() || message('error');
            if (!response.ok) status.textContent += ' (HTTP ' + response.status + ')';
            retry.hidden = false;
          }
        } catch {
          status.textContent = message('error'); retry.hidden = false;
        }
        finally { this.busy = false; this.clearPending(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wulist"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wusocial-video-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-video-lazy-grid')) {
    customElements.define('social-video-lazy-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.setupMedia({ signal: this.abort.signal });
      }
      setupMedia(options) {
        const root = this.closest('.social-video-grid');
        const autoplay = root.dataset.autoplay === 'true';
        const loop = root.dataset.loop === 'true';
        const controls = root.dataset.controls === 'true';
    const buildSocialPlayer = value => {
      try {
        const url = new URL(value);
        const host = url.hostname.replace(/^www\./, '').toLowerCase();
        if (host === 'tiktok.com' || host.endsWith('.tiktok.com')) {
          const match = url.pathname.match(/\/(?:video|player\/v1)\/(\d+)/);
          if (!match) return null;
          const params = new URLSearchParams({
            autoplay: autoplay ? '1' : '0',
            muted: '1',
            loop: loop ? '1' : '0',
            controls: controls ? '1' : '0',
            description: '0',
            music_info: '0',
            rel: '0'
          });
          return { provider: 'tiktok', src: `https://www.tiktok.com/player/v1/${match[1]}?${params}` };
        }
        if (host === 'instagram.com' || host.endsWith('.instagram.com')) {
          const match = url.pathname.match(/^\/(reel|reels|p|tv)\/([^/?#]+)/i);
          if (!match) return null;
          return { provider: 'instagram', unsupportedEmbed: true };
        }
      } catch (error) {
        return null;
      }
      return null;
    };
        this.autoPlayMedia = autoplay;
        this.muteMedia = autoplay || root.dataset.muted === 'true';
        this.showControls = controls;
        this.visibleMedia = new Set();
        this.mediaStates = [];
        this.querySelectorAll('[data-video-template]').forEach(template => {
          const card = template.closest('.social-video-grid__card');
          const social = template.content.querySelector('[data-social-video-url]');
          if (social) {
            const player = buildSocialPlayer(social.dataset.socialVideoUrl);
            if (!player) { card.hidden = true; return; }
            if (player.unsupportedEmbed) {
              const notice = template.content.querySelector('[data-instagram-notice]');
              if (!notice) { card.hidden = true; return; }
              social.remove();
              notice.hidden = false;
            } else {
              social.src = player.src;
            }
          }
          const state = { card, template, live: card.querySelector('[data-video-live]'), time: 0 };
          this.mediaStates.push(state);
        });
        this.mediaObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const state = this.mediaStates.find(item => item.card === entry.target);
            if (entry.isIntersecting && entry.intersectionRatio >= 0.05) this.visibleMedia.add(state);
            else this.visibleMedia.delete(state);
            this.syncMedia(state);
          });
        }, { threshold: [0, 0.05] });
        this.mediaStates.forEach(state => this.mediaObserver.observe(state.card));
        document.addEventListener('visibilitychange', () => {
          this.mediaStates.forEach(state => this.syncMedia(state));
        }, options);
        this.motion.addEventListener('change', () => {
          this.mediaStates.forEach(state => { this.releaseMedia(state); this.syncMedia(state); });
        }, options);
      }
      syncMedia(state) {
        if (!this.visibleMedia.has(state) || document.hidden) { this.releaseMedia(state); return; }
        if (state.live.childNodes.length) return;
        const fragment = state.template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        const frame = fragment.querySelector('iframe');
        const shouldPlay = this.autoPlayMedia && !this.motion.matches;
        if (video) {
          video.autoplay = false;
          video.muted = this.muteMedia;
          video.defaultMuted = this.muteMedia;
          video.playsInline = true;
          video.controls = this.showControls || !shouldPlay;
          video.preload = shouldPlay ? 'auto' : 'metadata';
          if (state.time > 0) video.addEventListener('loadedmetadata', () => {
            if (Number.isFinite(video.duration) && state.time < video.duration) video.currentTime = state.time;
          }, { once: true });
        }
        if (frame) {
          const url = new URL(frame.getAttribute('src'), location.href);
          url.searchParams.set('autoplay', shouldPlay ? '1' : '0');
          if (!shouldPlay) url.searchParams.set('controls', '1');
          if (url.hostname.includes('youtube')) url.searchParams.set('mute', this.muteMedia ? '1' : '0');
          else url.searchParams.set('muted', this.muteMedia ? '1' : '0');
          frame.src = url.href;
          frame.loading = 'eager';
        }
        state.live.append(fragment);
        if (video && shouldPlay) video.play().catch(() => {
          if (video.isConnected) video.controls = true;
        });
      }
      releaseMedia(state) {
        const video = state.live.querySelector('video');
        if (video) {
          if (video.currentTime > 0) state.time = video.currentTime;
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
        }
        state.live.replaceChildren();
      }

      disconnectedCallback() {
        this.mediaObserver?.disconnect();
        this.mediaStates?.forEach(state => this.releaseMedia(state));
        this.visibleMedia?.clear();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
